import { render, staticRenderFns } from "./add-variant-to-cart.vue?vue&type=template&id=54bd02f5&"
import script from "./add-variant-to-cart.vue?vue&type=script&lang=js&"
export * from "./add-variant-to-cart.vue?vue&type=script&lang=js&"
import style0 from "./add-variant-to-cart.vue?vue&type=style&index=0&id=54bd02f5&prod&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports